import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.scss"],
})

export class AboutUsComponent implements OnInit {
  platform: string = "";
  constructor(private router: Router,
   private service: TranslocoService
  ) {
    
  }

  ngOnInit() {
    this.platform = localStorage.getItem("platform");
    localStorage.setItem("lastRoute", this.router.url);
  }
}

